import React from 'react';
import { ErrorMessage, useField } from 'formik';

const FormField = ({ label, ...props }) => {
    const [field, meta] = useField(props);

    return (
        <div className="form-group mb-3 position-relative">
            <label htmlFor={field?.name}>{label}</label>
            <input className={`form-control shadow-none ${meta.touched && meta.error && 'is-invalid'}`} {...field} {...props} autoComplete="off" />
            <ErrorMessage component="div" className="mb-3 theme-field-error" name={field?.name || 'test'} />
        </div>
    );
};
export default FormField;
